import type { ReactNode } from 'react';

interface GenericCardProps {
  title?: string;
  subtitle?: string;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
}

export const GenericCard = ({
  title,
  subtitle,
  actions,
  children,
  className = '',
}: GenericCardProps) => {
  return (
    <section
      className={`bg-surface w-full rounded-2xl p-5 shadow-md ${className}`}
    >
      {(title || subtitle || actions) && (
        <header className="mb-4 flex items-start justify-between gap-4">
          <div>
            {title && (
              <h2 className="text-content font-lexend text-xl font-semibold">
                {title}
              </h2>
            )}
            {subtitle && (
              <p className="text-muted mt-1 text-sm">{subtitle}</p>
            )}
          </div>
          {actions}
        </header>
      )}
      {children}
    </section>
  );
};
